import React, { useEffect, useMemo, useState } from "react";
import MenuContainer from "../../Components/MenuContainer/MenuContainer";
import Loader from "../../Components/LoaderComponent/Loader";
import { Table, Button, Upload } from "@arco-design/web-react";
import HeaderSection from "../../Components/HeaderSection";
import { IconPlus } from "@arco-design/web-react/icon";
import AlertBox from "../../Components/AlertBox/AlertBox";
import { ManageApis } from "../../AppServices/ManageApi";
import { getBase64, getLocalStorage } from "../../Functions/Utils";
import { useStoreValues } from "../../Context/storeProvider";
import PDFUploadForm from "./PDFUploadForm";
import DocumentComparisonResult from "./DocumentComparisonResult";

function DocumentComparison({ selectedMenu }) {
  console.log("asdasdsasa menu list ----->", selectedMenu);
  const { menuList } = useStoreValues();
  const [isLoading, setisLoading] = useState(false);
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);

  const [fileName1, setFileName1] = useState("");
  const [fileType1, setFileType1] = useState("");
  const [fileName2, setFileName2] = useState("");
  const [fileType2, setFileType2] = useState("");
  const [visible, setvisible] = useState({ show: false, message: "" });
  const [showResults, setShowResults] = useState(false);
  const [result, setResult] = useState(null);
  const [resultsData, setResultsData] = useState(null);
  const AlertinitialValue = {
    show: false,
    message: "",
    isfalse: false,
    isSuccess: false,
  };
  const [showAlert, setShowAlert] = useState(AlertinitialValue);

  //   const findMenuId = {}
  const findMenuId = menuList.find(
    (menuItem) => menuItem.menuName === selectedMenu
  );

  const handleFileChange = (e, uploadIndex) => {
    const file = e[0]?.originFile || null;

    if (file) {
      const extension = file.name.split(".").pop().toLowerCase();
      const validExtensions = [
        "pdf",
        "doc",
        "docx",
        "ppt",
        "pptx",
        "jpeg",
        "png",
        "jpg",
      ];

      if (validExtensions.includes(extension)) {
        if (uploadIndex === 1) {
          setFileName1(file.name);
          setFile1(file);
          setFileType1(
            extension === "pdf"
              ? "PDF"
              : extension.includes("doc")
              ? "Word"
              : extension.includes("ppt")
              ? "PowerPoint"
              : "Image"
          );
        } else if (uploadIndex === 2) {
          setFileName2(file.name);
          setFile2(file);
          setFileType2(
            extension === "pdf"
              ? "PDF"
              : extension.includes("doc")
              ? "Word"
              : extension.includes("ppt")
              ? "PowerPoint"
              : "Image"
          );
        }
      } else {
        setvisible({
          show: true,
          message:
            "Unsupported file type! Please upload only Word, PowerPoint, PDF, or image files.",
          alertType: "warning",
        });
        if (uploadIndex === 1) {
          setFileName1("");
          setFileType1("");
          setFile1(null);
        } else if (uploadIndex === 2) {
          setFileName2("");
          setFileType2("");
          setFile2(null);
        }
      }
    } else {
      if (uploadIndex === 1) {
        setFileName1("");
        setFileType1("");
        setFile1(null);
      } else if (uploadIndex === 2) {
        setFileName2("");
        setFileType2("");
        setFile2(null);
      }
    }
  };

  const documentComparison = async () => {
        // Check if both files are uploaded
      if (!file1 || !file2) {
        setShowAlert({
          show: true,
          message: "Please upload both files before proceeding.",
          isfalse: true,
        });
        return; // Exit the function if files are not present
      }
      
    setisLoading(true);
    try {
      const base64File1 = await getBase64(file1);
      const base64File2 = await getBase64(file2);

      const reqBody = {
        userId: Number(getLocalStorage("clientId")),
        menuId: Number(findMenuId?.id),
        AccountsId: Number(getLocalStorage("accountsId")),
        hhli: base64File1,
        poi: base64File2,
      };
      console.log("path here --->");
      const result = await ManageApis(
        "post",
        global.harmonyDocumentComparison,
        reqBody
      );
      console.log(
        result,
        "rewulttttttttttt-.................................."
      );
      if (result.status_code === 200) {
        console.log("response from API call -->", result);
        let customErrorMsg =""
        if (result.message === "Success") {
            if (result.response_data.message.includes("Your trying limit is over, please contact with support team") ) {
                customErrorMsg = "Your trying limit is over, please contact with support team"
            }
        }else{
        customErrorMsg = result.response_data.message
        }
        if (customErrorMsg) {
            setShowAlert((pre) => ({
                ...pre,
                show: true,
                message: customErrorMsg,
                isfalse: true
              }));
            
        }
        const parseData = JSON.parse(result.response_data.message);
        setResult(parseData);
        setResultsData(parseData.detail);
        setisLoading(false);
        setShowResults(true);
      } else if (result.status_code === 400) {
        console.log("API response failed");
        setisLoading(false);
        setvisible({
          show: true,
          message: "Internal server error",
          alertType: "error",
        });
      }
    } catch (e) {
      console.log("Error while sending API ", e);
      setisLoading(false);
      setvisible({
        show: true,
        message: "Error Sending API call",
        alertType: "error",
      });
    }
  };

  const handleFileRemove = (uploadIndex) => {
    if (uploadIndex === 1) {
      setFileName1("");
      setFileType1("");
      setFile1(null);
    } else if (uploadIndex === 2) {
      setFileName2("");
      setFileType2("");
      setFile2(null);
    }
  };

  return (
    <div>
      {isLoading && <Loader />}
      {
        <AlertBox
        show={showAlert.show}
        message={showAlert.message}
        enableFailIcon={showAlert.isfalse}
        enableSuccessIcon={showAlert.isSuccess}
        handlecancel={() => setShowAlert(AlertinitialValue)}
      />
      }
      {!showResults && (
        <div className="py-5 ">
          <h2 class="font_22 text_master2 fw-bold mb-0  text-center pb-5">
            Document Comparison
          </h2>
          <div className="bg_gray2 max_w_1000x w-100 p-5 pb-2 m-auto">
            <PDFUploadForm
              file1={file1}
              fileName1={fileName1}
              fileType1={fileType1}
              file2={file2}
              fileName2={fileName2}
              fileType2={fileType2}
              handleFileChange={handleFileChange}
              documentComparison={documentComparison}
              handleFileRemove={handleFileRemove}
            />
          </div>
        </div>
      )}
      {/* after upload then show this component */}

      {showResults && (
        <DocumentComparisonResult
          resultsData={resultsData}
          file1={file1}
          file2={file2}
        />
      )}
    </div>
  );
}

export default DocumentComparison;
